<div
  *ngIf="show$ | async"
  class="bg-brand-yellow padding-y-s text-center row justify-content-center align-items-center"
>
  <div class="col-auto">
    <a
      href="https://video.ikea.net/media/1_u3q0kndx"
      linkColor="black"
      fontSize="small"
      rel="noopener noreferrer"
      target="_blank"
      [prefix]="prefix"
      app-fm-hyperlink
    >
      <b>Hej!</b> New to IKEA Media Content Centre? Check out our quick
      tutorial.
    </a>
  </div>

  <div class="col-auto">
    <app-fm-icon-button
      (click)="dismiss()"
      icon="cross-24"
      [prefix]="prefix"
    ></app-fm-icon-button>
  </div>
</div>
